// Opções comuns do Socket.IO. WebSocket primeiro: é uma conexão única, então funciona com
// várias réplicas da API sem sessão fixa no balanceador. Polling só como alternativa para
// redes que bloqueiam WebSocket.
export const SOCKET_TRANSPORTS = ["websocket", "polling"];
